import React from 'react';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import DocIcon from 'shared/components/event/docIcon.jsx';
import DisplayTypeIcon from 'shared/components/show/displayTypeIcon.jsx';
import {
  isDocFSObject,
  isShowFSObject,
  getFSRefObject,
} from 'shared/components/event/fsObjectUtils';

/* eslint-disable react/prop-types */
const FSObjectIcon = ({ item }) => {
  let node = <Icon name="folder" />;
  if (isDocFSObject(item)) {
    node = <DocIcon doc={getFSRefObject(item)} />;
  } else if (isShowFSObject(item)) {
    node = (
      <DisplayTypeIcon
        displayType={item.getIn(['reference', 'object', 'displayType'])}
      />
    );
  } else if (item.get('displayType')) {
    node = <DisplayTypeIcon displayType={item.getIn(['displayType'])} />;
  }

  return <div className="fs-object-icon">{node}</div>;
};
/* eslint-enable react/prop-types */

export default FSObjectIcon;
